import { BackendConfig } from 'types/Search/form';

export const config: BackendConfig = {
    defaultDaysBetween: 7,
    minDaysBetween: 2,
    maxRange: 541,
    maxFutureDay: 541,
    travelDates: null,
    holidays: [],
    vacations: [],
    delayForEndElementCloseAfterRangeComplete: 150,
    format: 'dd.MM.yyyy',
    numberofMonths: 2,
    dateTimeFormatOptions: {
        weekday: 'short',
        month: '2-digit',
        day: '2-digit',
    },
};
